import React from 'react';
import {
  Bubble,
  RenderMessageImageProps,
  TimeProps,
} from 'react-native-gifted-chat';
import {StyleProp, TextStyle, ViewStyle} from 'react-native';
import Animated, {
  withSequence,
  withTiming,
  useSharedValue,
} from 'react-native-reanimated';
import {Text, useTheme} from 'react-native-paper';
import {ChatBubbleImage} from './bubbleimage';
import {ChatBubbleTime} from './bubbletime';
import {ChatMessage, RenderBubbleProps} from '../../../types';

export function ChatBubble(props: RenderBubbleProps) {
  const opacity = useSharedValue(1);
  const theme = useTheme();

  if (props.isPreloader) {
    opacity.value = withSequence(
      withTiming(0.2, {duration: 500}),
      withTiming(1, {duration: 500}),
    );
  }

  const textStyle: StyleProp<TextStyle> = {
    ...theme.fonts.bodyMedium,
    color: props.isPreloader ? 'transparent' : theme.colors.onSurface,
    margin: 0,
  };
  if (props.currentMessage?.media) {
    const type =
      props.currentMessage.media.type ||
      props.currentMessage.media.fileType;
    // const url = props.currentMessage.media.url;
    // if (type?.search('image') > -1) {
    //   props.currentMessage.image = url;
    // }
    // if (type?.search('video') > -1) {
    //   props.currentMessage.video = url;
    // }
    // if (type?.search('audio') > -1) {
    //   props.currentMessage.audio = url;
    // }
  }
  return (
    <Animated.View style={{opacity}}>
      <Bubble
        {...props}
        textStyle={{
          left: textStyle,
          right: textStyle,
        }}
        renderMessageText={(textProps: RenderBubbleProps) => (
          <Text theme={theme}>{textProps.currentMessage?.text}</Text>
        )}
        renderMessageImage={imageProps => (
          <ChatBubbleImage
            {...(imageProps as RenderMessageImageProps<ChatMessage>)}
          />
        )}
        renderTime={timeProps =>
          !props.isPreloader && (
            <ChatBubbleTime
              timeProps={timeProps as TimeProps<ChatMessage>}
              chatId={props.chatId}
            />
          )
        }
        renderTicks={() => null}
        wrapperStyle={{
          right: {
            ...wrapperStyles,
            minWidth: 'auto',
            maxWidth: 300,
            backgroundColor: '#871e69',
          },
          left: {
            ...wrapperStyles,
            maxWidth: 300,
            backgroundColor: props.bgColor,
          },
        }}
      />
    </Animated.View>
  );
}

const wrapperStyles: ViewStyle = {
  alignSelf: 'auto',
  maxWidth: '100%',
  minHeight: 50,
  // minWidth: 220,
  marginBottom: 48,
  display: 'flex',
  borderRadius: 22,
  padding: 16,
};
